import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import styled from 'styled-components';
import { HTML } from './HTML';
var LinkStyles = styled.div.withConfig({
  displayName: "Nl2br__LinkStyles",
  componentId: "sc-1wvb5c8-0"
})(["a{color:", ";&:hover{opacity:0.75;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mainColor;
});
var newlineRegex = /(\r\n|\r|\n)/g;
export var Nl2br = function Nl2br(_ref2) {
  var text = _ref2.text;
  var lines = text.split(newlineRegex);
  return lines.map(function (line, index) {
    if (!line.length) {
      return React.createElement("br", {
        key: index
      });
    }
    return React.createElement(HTML, {
      key: index,
      html: line,
      allowedTags: ['a', 'div'],
      wrapper: LinkStyles
    });
  });
};